import { ComponentsOverrides, Theme } from "@mui/material";
import { ciCustomColors } from "./colors";

type MuiDivider = {
  styleOverrides: ComponentsOverrides<Theme>["MuiDivider"];
};

const muiDivider: MuiDivider = {
  styleOverrides: {
    root: {
      borderColor: ciCustomColors.blue[50],
    },
  },
};

export default muiDivider;
